<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg6>
          <BusinessForm
            v-model="business"
            @submit="save"
            :backLink="business.url"
            title="Geschäft bearbeiten"
            submitText="Aktualisieren"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </BaseLayout>
</template>

<script>
import Business from '@/models/business';
import Commission from '@/models/commission';

export default {
  name: 'EditBusiness',
  requireSuperuser: true,
  async asyncData({ id }) {
    await Business.findOrFetch(id);
    await Commission.fetchAll();
  },
  data() {
    return {
      business: Business.find(this.$route.params.id),
    };
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        await this.business.update();
        this.$showSnackbar({ text: 'Erfolgreich gespeichert.', color: 'success' });
        this.$router.push(this.business.url);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
